<div class="cl-tabs">
  <ul class="nav nav-tabs">
    @for (tab of tabs; track tab) {
      <li (click)="selectTab(tab)" [class.active]="tab.active()">
        <label>{{tab.tab_title}}</label>
      </li>
    }
  </ul>
</div>
<ng-content></ng-content>
